import { render, staticRenderFns } from "./Certs.vue?vue&type=template&id=6b215c6b&"
import script from "./Certs.vue?vue&type=script&lang=js&"
export * from "./Certs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports